import SweetScroll from 'sweet-scroll';

new SweetScroll();

var collapse = document.querySelector('.collapse');
var collapsed = true;
document.getElementById('collapse-trigger')
.addEventListener('click', () => {
  collapse.style.display = collapsed ? 'flex' : '';
  collapsed = !collapsed;
});
// Collapse when an item is selected
Array.prototype.slice.call(document.querySelectorAll('.collapse a'))
.forEach(item => {
  item.addEventListener('click', () => {
    collapse.style.display = '';
    collapsed = true;
  });
});

var backTop = document.getElementById('backTop');
window.addEventListener('scroll', function(){
  if (window.pageYOffset < 100) backTop.style.bottom = '-100px';
  else backTop.style.bottom = '1rem';
});
